import { render, staticRenderFns } from "./ViewPension.vue?vue&type=template&id=4d697c0b&scoped=true"
import script from "./ViewPension.vue?vue&type=script&lang=js"
export * from "./ViewPension.vue?vue&type=script&lang=js"
import style0 from "./ViewPension.vue?vue&type=style&index=0&id=4d697c0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d697c0b",
  null
  
)

export default component.exports